<template>
    <v-row justify="center" class="reportcontainer">
        <v-col cols="auto" sm="12" md="10" lg="8" class="ma-2 ma-md-5 ma-sm-2" v-if="reports_checkstatus.reportConfig" id='reportwrapper'>
            <div id="messagepanel" class="float-right">
                <v-chip v-if="reports_checkstatus.reportConfig.reportstatus === 'private'"
                    color="orange darken-4" text-color="white" >
                    This report is Private.
                </v-chip>
                <v-btn v-if="!showConfig && reports_checkstatus.reportConfig && reports_checkstatus.reportConfig.showConfig"
                    color="secondary" id="settingsbutton" text-color="white" class="elevation-1 ml-1" v-on:click="toggleConfig">
                    Settings
                    <v-icon dark right>settings</v-icon>
                </v-btn>
                <v-btn color="secondary" class="elevation-1 ml-1" id="reportloginbutton" small v-on:click="callLogin" v-if="reports_checkstatus.reportConfig && !reports_checkstatus.reportConfig.contactid">
                    Login
                </v-btn>                
            </div>
            <div v-html="makeTitle()" id="reportTitleContainer"></div>

            <slide-up-down :active="configActive" :duration="500">
                <ReportSettings v-on:closeConfig="toggleConfig"  :reportid="reportid"  />
            </slide-up-down>

            <div id="statusoverview" v-if="mergedConfig.showsummary">
                <v-card :class="getStatusSummaryClass()" >
                    <v-card-text>
                        <v-row  justify="space-between" class="mb-2">
                            <v-col class="headline white--text pl2" v-html="makeTitle('summarytitle')" />
                        </v-row>
                    </v-card-text>
                </v-card>
            </div>

            <CheckProperties v-if="!mergedConfig.hidecheckproperties" />

            <div v-if="mergedConfig.showuptime" id="uptimewrapper">
                <ReportUptime :runpolling="ispolling" :reportid="reportid" />
            </div>

            <div id="checknote1" v-if="!mergedConfig.hidenote1 && mergedConfig.note1 && mergedConfig.note1.length" class="supportnote" v-html="mergedConfig.note1" />

            <div v-if="!mergedConfig.hideresultslist || !mergedConfig.hidechart" id="resultswrapper">
                <ReportResults :runpolling="ispolling" :reportid="reportid" :showConfig="showConfig" />
            </div>
            <div v-else>
                <!--
                <div>Show results list: {{mergedConfig.showresultslist}} </div>
                <div>Show results chart: {{mergedConfig.showchart}} </div>
                <div>Is Polling: {{ispolling}} </div>
                <div>Report ID: {{reportid}} </div>
                -->
            </div>

            <div id="checknote2" v-if="!mergedConfig.hidenote2 && mergedConfig.note2 && mergedConfig.note2.length" class="supportnote" v-html="mergedConfig.note2" />

            <div v-if="mergedConfig.showevents" id="eventswrapper">
                <ReportEvents :runpolling="ispolling" :reportid="reportid" />
            </div>

            <div id="customfooter" v-if="getFooter"  v-html="getFooter" ></div>

        </v-col>
        <div v-else-if="reports_checkstatus.error && reports_checkstatus.error.type === 'accessphrase' ">
            <div class="text-center" style="margin-top:64px;">
                <h3 class="errormessage" style="margin-bottom: 24px;">{{reports_checkstatus.error.message}}</h3>
                <v-text-field type="password" v-model="accessphrase" label="Access Phrase" outlined @keydown.enter="doAccessPhrase">  </v-text-field>
                <v-btn color="primary" class="elevation-1 ml-1" dark small @click="doAccessPhrase">Submit</v-btn>
                <pre>{{reportid}}</pre>
            </div>
        </div>
        <div v-else-if="reports_checkstatus.error">
            <div class="text-center" style="margin-top:64px;">
                <h3 class="errormessage">{{reports_checkstatus.error.message}}</h3>
                <h3 class="errormessage">
                    Response Status: {{reports_checkstatus.error.status}} {{reports_checkstatus.error.statusText}}
                </h3>
                <h3 class="errormessage" v-if="reports_checkstatus.error.login">
                    If this report exists, but is private or disabled, you may need to <a :href="'/account/sso?pn='+this.$route.fullPath">login</a>.
                </h3>
            </div>
        </div>
        <div v-else>
            <div class="text-center" style="margin-top:64px;">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
        </div>
    </v-row>

</template>

<script>
import { mapState, mapGetters } from "vuex";
import { filterId, formatCapitalizeFirst, filterDate } from "../lib/filter";
import { parse as date_parse } from "date-fns";
import ReportSettings from "./Reports_Checkstatus_Config";
import CheckProperties from "./Reports_Checkstatus_Checkproperties";
import ReportEvents from "./Reports_Checkstatus_Events";
import ReportResults from "./Reports_Checkstatus_Results";
import ReportUptime from "./Reports_Checkstatus_Uptime";
import SlideUpDown from 'vue-slide-up-down';

const defaultpagetitle = "NodePing Monitoring Check Status Report";
// results:  jobid, s, l, rt, sc, su, m, f

export default {
    name: "checkstatus",
    metaInfo ( ) {
        // console.log('metaInfo', this);
        return {
            title: this.getPageTitle,
            style: [{ cssText: this.getCSS }]
        }
    },
    props: {

        },
    components: { ReportSettings, ReportEvents, CheckProperties, ReportResults, ReportUptime, SlideUpDown },
    data() {
        return {
            report: "checkstatus",
            reportid: (window.reportid && filterId(window.reportid)) || this.$route.params.cid || this.$route.params.uuid,
            accessphrase: "",
            ispolling: false,
            pollconfig: true,
            pollcheck: true,
            showConfig: false,
            // resultsSet: false,
            chartOptions: false
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_checkstatus", "now"]),
        ...mapGetters("reports_checkstatus", ["mergedConfig"]), // this syntax means "The mergedConfig getter in the reports_checkstatus store"
        configActive: function () {
            return (this.showConfig && this.reports_checkstatus.reportConfig && this.reports_checkstatus.reportConfig.showConfig)
        },
        getCSS: function () {
            let css = "";
            if(this.reports_checkstatus.reportConfig){
                if( this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.stylecss && this.reports_checkstatus.reportConfig.check.stylecss.length){
                    css = this.reports_checkstatus.reportConfig.check.stylecss;
                } else if(this.reports_checkstatus.reportConfig.stylecss && this.reports_checkstatus.reportConfig.stylecss.length){
                    css = this.reports_checkstatus.reportConfig.stylecss;
                }
            }
            return css;
        },
        getFooter: function () {
            let footer = false;
            if(this.reports_checkstatus.reportConfig){
                if( this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.footer && this.reports_checkstatus.reportConfig.check.footer.length){
                    footer = this.reports_checkstatus.reportConfig.check.footer;
                } else if(this.reports_checkstatus.reportConfig.footer && this.reports_checkstatus.reportConfig.footer.length){
                    footer = this.reports_checkstatus.reportConfig.footer;
                }
            }
            return footer;
        },
        getPageTitle: function () {
            let pagetitle = defaultpagetitle;
            if(this.reports_checkstatus.reportConfig){
                if( this.reports_checkstatus.reportConfig.check && this.reports_checkstatus.reportConfig.check.pagetitle && this.reports_checkstatus.reportConfig.check.pagetitle.length){
                    pagetitle = this.reports_checkstatus.reportConfig.check.pagetitle;
                } else if(this.reports_checkstatus.reportConfig.pagetitle && this.reports_checkstatus.reportConfig.pagetitle.length){
                    pagetitle = this.reports_checkstatus.reportConfig.pagetitle;
                }
            }
            return pagetitle;
        }//,
        // mergedConfig: function () {
        //     let temp = Object.assign({}, this.reports_checkstatus.reportConfig.check);
        //     for(let k in temp){
        //         if(typeof temp[k] === "string" && !temp[k].length) delete temp[k];
        //     }
        //     return Object.assign({}, this.reports_checkstatus.reportConfig, temp);
        // }
    },
    methods: {
        doAccessPhrase: function () {
            // console.log('doAccessPhrase', this.accessphrase);
            this.startPolling();
        },
        startPolling: function () {
            const params = {
                reportid: this.reportid || this.$route.params.cid,
                skipconfig: !this.pollconfig,
                skipcheck: !this.pollcheck,
                skipresults: !this.skipresults,
                skipevents: !this.skipevents
            };
            // console.log("Check Status Polling for", params.reportid);
            if(this.accessphrase && this.accessphrase.length) params.accessphrase = this.accessphrase;
            this.$store
                .dispatch("reports_checkstatus/getReport", params)
                .then((record) => {
                    // console.log('getReport returned', record)
                    this.reportid = this.reports_checkstatus.reportid;

                    clearTimeout(this.$options.polling);
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                    setTimeout(() => {
                        this.ispolling = true;
                        return true;
                    }, 333);
                })
                .catch( () => {
                    clearTimeout(this.$options.polling);
                    this.$options.polling = setTimeout( this.startPolling, 60000);
                });
        },
        stopPolling: function () {
            this.ispolling = false;
            clearTimeout(this.$options.polling);
        },
        makeTitle: function (field) {
            let title;
            if(!this.reports_checkstatus.reportConfig) return "";
            field = field || "title";
            if(field === "summarytitle") field = (this.reports_checkstatus.reportCheck.state) ? "summarytitleup" : "summarytitledown";

            if(this.mergedConfig[field] && this.mergedConfig[field].length){
                title = this.mergedConfig[field];
            } else {
                // set to default
                switch(field){
                    case 'summarytitleup':
                        title = "{label} is Up";
                        break;
                    case 'summarytitledown':
                        title = "{label} is Down";
                        break;
                    default:
                        title = this.reports_checkstatus.reportCheck.type + " Check on " + (this.reports_checkstatus.reportCheck.label || this.reports_checkstatus.reportCheck.target || this.reports_checkstatus.reportCheck._id );
                }
            }
            if (!title || title === "") return "";

            title = title.replace(/{\s*label\s*}/ig, this.reports_checkstatus.reportCheck.label || "");
            title = title.replace(/{\s*target\s*}/ig, this.reports_checkstatus.reportCheck.target || "");
            title = title.replace(/{\s*type\s*}/ig, this.reports_checkstatus.reportCheck.type || "");
            if( field === "title" && !(title.includes("<")) ) title = "<h1>" + title + "</h1>";

            return title;
        },
        getStatusSummaryClass: function () {
            let summaryClass = (this.reports_checkstatus.reportCheck.state > 0) ? "summaryblockup" : "summaryblockdown";
            return 'dashboard jobrow elevation-3 mb-4 justify-center ' + summaryClass;
        },
        callLogin: function () {
            window.location.href="/account/sso?pn="+this.$route.fullPath;
        },        
        toggleConfig: function () {
            this.showConfig = !this.showConfig;
            if(this.showConfig){ this.stopPolling(); } else { this.startPolling(); }
        }
    },
    mounted () {


    },
    created () {
        this.startPolling();
    },
    beforeDestroy: function () {
        this.stopPolling()
    }
}
</script>

<style scoped>
#reportTitleContainer {
    margin-bottom: 12px;
    padding-top: 1rem;
    padding-bottom: 1rem;
}
#chartcontainer {
    height: 420px;
    width: 100%;
}
#uptimewrapper {
    padding-bottom: 12px;
}
.summaryblockdown {
    background-color: #e65100;
    border-color: #e65100;
}
.summaryblockup {
    background-color: #388E3C ;
    border-color: #388E3C;
}
</style>

<style>
.reportcontainer {
    margin-top: 32px;
    padding: 0 8px;
}
.cardtitle {
    display: block;
    font-size: 1.5em;
    margin-block-start: 0.83em;
    margin-block-end: 0.83em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    margin-bottom: 1em;
    color: #111;
}
</style>
